import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=c804d438&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kusanagi/adop-line-ec_plaisir/ec/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c804d438')) {
      api.createRecord('c804d438', component.options)
    } else {
      api.reload('c804d438', component.options)
    }
    module.hot.accept("./Product.vue?vue&type=template&id=c804d438&", function () {
      api.rerender('c804d438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Product.vue"
export default component.exports